<template>
  <div class="auth-container">
    <!-- ログイン・サインアップ時のフルスクリーンローディング -->
    <LoadingModal :visible="isLoading" />

    <div class="auth-card">
             <h2 class="auth-title">オトエイゴ</h2>
      <!--<p class="auth-tagline">14日間無料体験で、まずはお試しください</p>

      <!-- ログインブロック：既存ユーザーはここだけ見ればOK -->
      <section v-if="isLoginMode && !isResetMode" class="login-block">
        <h3 class="login-heading">ログインしてください</h3>
        <form @submit.prevent="handleLogin" class="auth-form">
          <div class="form-group">
            <label for="email">メールアドレス</label>
          <input
            id="email"
            v-model="loginForm.email"
            type="email"
            required
            placeholder="example@email.com"
            class="form-input"
            autocomplete="email"
          />
        </div>
        
        <div class="form-group">
          <label for="password">パスワード</label>
          <input
            id="password"
            v-model="loginForm.password"
            type="password"
            required
            placeholder="パスワードを入力"
            class="form-input"
            autocomplete="current-password"
          />
        </div>
        
        <button type="submit" :disabled="isLoading" class="btn btn-primary">
          {{ isLoading ? 'ログイン中...' : 'ログイン' }}
        </button>
        
          <div class="auth-links">
            <button type="button" @click="switchToReset" class="btn-link">
              パスワードを忘れた方
            </button>
          </div>
        </form>
        <p class="login-to-signup">
          <button type="button" @click="switchToSignUp" class="btn-link btn-link-signup">
            無料登録はコチラ
          </button>
        </p>
      </section>

      <!-- 無料体験登録ブロック：メール + パスワード → 認証メール → 決済 -->
      <section v-if="!isLoginMode && !isResetMode" class="signup-section">
        <!-- メール送信完了時 -->
        <div v-if="emailLinkSent" class="signup-success-panel">
          <div class="signup-success-icon" aria-hidden="true">✓</div>
          <h3 class="signup-success-title">メールを送信しました！</h3>
          <div class="signup-success-body">
            <p>ご入力いただいたアドレスに、アカウント登録用のリンクをお送りしました。</p>
            <p>メール内のリンクをクリックして、登録を進めましょう！</p>
            <p class="signup-success-note">※届かない場合は、迷惑メールフォルダもご確認ください。</p>
          </div>
          <div class="signup-success-actions">
            <button type="button" @click="handleResendMagicLink" :disabled="isLoading" class="btn btn-outline">メールを再送する</button>
            <button type="button" @click="resetEmailSent" class="btn btn-outline">別のアドレスで送る</button>
            <button type="button" @click="switchToLogin" class="btn-link">すでにアカウントをお持ちの方はこちらからログイン</button>
          </div>
        </div>
        <!-- メール入力フォーム -->
        <template v-else>
          <p class="signup-lead">メールアドレスとパスワードを入力し、<br>届いたメール内のリンクから<br>申し込みへ進んでください。</p>
          <form @submit.prevent="handleSignUp" class="auth-form signup-form">
            <div class="form-group">
              <label for="signup-email">メールアドレス</label>
              <input
                id="signup-email"
                v-model="signUpForm.email"
                type="email"
                required
                placeholder="example@email.com"
                class="form-input"
                autocomplete="email"
              />
            </div>
            <div class="form-group">
              <label for="signup-password">パスワード</label>
              <input
                id="signup-password"
                v-model="signUpForm.password"
                type="password"
                required
                placeholder="パスワードを入力"
                class="form-input"
                autocomplete="new-password"
              />
            </div>
            <div class="form-group">
              <label for="signup-password-confirm">パスワード（確認）</label>
              <input
                id="signup-password-confirm"
                v-model="signUpForm.passwordConfirm"
                type="password"
                required
                placeholder="同じパスワードを再入力"
                class="form-input"
                autocomplete="new-password"
                :class="{ 'form-input-error': signUpForm.passwordConfirm && signUpForm.password !== signUpForm.passwordConfirm }"
              />
              <p v-if="signUpForm.passwordConfirm && signUpForm.password !== signUpForm.passwordConfirm" class="form-error-inline">
                パスワードが一致しません
              </p>
            </div>
            <button type="submit" :disabled="isLoading || !canSignUp" class="btn btn-primary signup-submit">
              {{ isLoading ? '送信中...' : '無料で登録する' }}
            </button>
            <div class="auth-links">
              <button type="button" @click="switchToLogin" class="btn-link">
                すでにアカウントをお持ちの方は<br>こちらからログイン
              </button>
            </div>
          </form>
        </template>
      </section>
      
      <!-- パスワードリセットフォーム -->
      <form v-if="isResetMode" @submit.prevent="handlePasswordReset" class="auth-form">
        <div class="form-group">
          <label for="reset-email">メールアドレス</label>
          <input
            id="reset-email"
            v-model="resetForm.email"
            type="email"
            required
            placeholder="登録済みのメールアドレス"
            class="form-input"
          />
        </div>
        
        <button type="submit" :disabled="isLoading" class="btn btn-primary">
          {{ isLoading ? '送信中...' : 'パスワードリセット' }}
        </button>
        
        <div class="auth-links">
          <button type="button" @click="switchToLogin" class="btn-link">
            ログインに戻る
          </button>
        </div>
      </form>
      
      <!-- エラーメッセージ -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>

      <!-- ログイン後の回復導線（遷移だけやり直す／裏の認証が終わらないときの再読み込み） -->
      <div v-if="canRetryNavigation || showReloadHint" class="login-recovery-actions">
        <button v-if="canRetryNavigation" type="button" class="btn btn-primary" @click="retryNavigationAfterLogin">
          もう一度進む
        </button>
        <button v-if="showReloadHint" type="button" class="btn btn-outline" @click="reloadPage">
          ページを再読み込みする
        </button>
      </div>
      
      <!-- 成功メッセージ -->
      <div v-if="successMessage" class="success-message">
        {{ successMessage }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import { supabase } from '../../supabaseClient'
import { getApiBase } from '../../utils/apiBase.js'
import LoadingModal from '../common/LoadingModal.vue'
import { beginLoginAttempt, markLoginStage, classifyAuthError } from '../../utils/loginTelemetry.js'
import { createLoginFlow } from '../../utils/loginFlow.js'
import { seedAuthUser } from '../../composables/useAuthUser.js'

const router = useRouter()
const route = useRoute()

const isManagerLoginEntry = computed(() => route.path === '/manager/login')

// ファーストビューは無料体験登録（新規ユーザー優先）。
// ただし /manager/login ではログイン画面を最初に出す
const isLoginMode = ref(isManagerLoginEntry.value)
const isLoading = ref(false)
const errorMessage = ref('')
const successMessage = ref('')
// 案B: Magic Link 送信完了時
const emailLinkSent = ref(false)

// ログインフォーム
const loginForm = ref({
  email: '',
  password: ''
})

// サインアップフォーム（メール + パスワード → 認証メール → 決済）
const signUpForm = ref({
  email: '',
  password: '',
  passwordConfirm: ''
})

// パスワードリセットフォーム
const resetForm = ref({
  email: ''
})

const isResetMode = ref(false)

// バリデーション
const canSignUp = computed(() =>
  signUpForm.value.email &&
  signUpForm.value.password &&
  signUpForm.value.passwordConfirm &&
  signUpForm.value.password === signUpForm.value.passwordConfirm
)

const canLogin = computed(() => {
  return loginForm.value.email && loginForm.value.password
})

const canReset = computed(() => {
  return resetForm.value.email
})

// ログイン後の回復導線
const showReloadHint = ref(false)
const canRetryNavigation = ref(false)
let isMounted = true
onUnmounted(() => { isMounted = false })

const isLoginRouteName = (name) => name === 'Login' || name === 'ManagerLogin'

// 認証エラーの表示（パスワード違いと通信の問題を分ける）
const authErrorMessage = (error, errorClass) => {
  if (errorClass === 'invalid_credentials') return 'メールアドレスまたはパスワードが正しくありません。'
  if (errorClass === 'email_not_confirmed') return 'メールアドレスの確認が完了していません。届いたメールのリンクを開いてから、ログインしてください。'
  if (errorClass === 'network') return '通信できませんでした。通信状態を確認して、もう一度お試しください。'
  return error?.message || 'ログインに失敗しました'
}

const NAVIGATION_WAITING_MESSAGE =
  'ログインできましたが、画面の読み込みに時間がかかっています。「もう一度進む」を押すか、ページを再読み込みしてください。'

const WAITING_FOR_AUTH_MESSAGE =
  '通信に時間がかかっています。ログインの結果を待っています。しばらくたっても進まない場合は、ページを再読み込みしてください。'

// ログインの流れ（認証は同時に1つだけ、固定待機なし、遷移の結果まで扱う。指示書 A2）。
// 遷移の責任者はこの流れだけ（App.vue の認証通知 SIGNED_IN からは遷移しない）
const loginFlow = createLoginFlow({
  signIn: (email, password) => supabase.auth.signInWithPassword({ email, password }),
  navigate: (path) => router.push(path),
  isStillOnLogin: () => isMounted && isLoginRouteName(route.name),
  onAuthenticated: (user) => {
    markLoginStage('auth_completed')
    // ログイン成功の応答のユーザーを、確認済みとして共有する（直後のガードで認証サーバーへ問い合わせ直さない。指示書 ④）
    seedAuthUser(user)
    errorMessage.value = ''
    showReloadHint.value = false
    successMessage.value = 'ログインに成功しました！'
    // ログインのたびのプロフィール保存はしない（指示書 ②・A6）。
    // プロフィールの作成は新規登録（DB）、名前は初期登録・マイページ、メールアドレスの変更はガードで反映する
  },
  onLateResult: (result) => applyLoginResult(result)
})

const applyLoginResult = (result) => {
  isLoading.value = false
  canRetryNavigation.value = false
  switch (result?.kind) {
    case 'navigated':
      showReloadHint.value = false
      errorMessage.value = ''
      return
    case 'left_login_screen':
    case 'superseded':
      return
    case 'auth_error': {
      const errorClass = classifyAuthError(result.error)
      markLoginStage(errorClass === 'timeout' ? 'auth_wait_timeout' : 'auth_failed', { error_class: errorClass, http_status: result.error?.status })
      successMessage.value = ''
      showReloadHint.value = false
      errorMessage.value = authErrorMessage(result.error, errorClass)
      return
    }
    case 'auth_waiting':
      markLoginStage('auth_wait_timeout', { error_class: 'timeout' })
      errorMessage.value = WAITING_FOR_AUTH_MESSAGE
      showReloadHint.value = true
      return
    case 'navigation_failed':
      errorMessage.value = '画面を移動できませんでした。「もう一度進む」を押してください。'
      canRetryNavigation.value = loginFlow.canRetryNavigation
      return
    case 'navigation_waiting':
      // ログインは済んでいる。画面の読み込みが止まっているので、やり直しか再読み込みを案内する
      errorMessage.value = NAVIGATION_WAITING_MESSAGE
      canRetryNavigation.value = loginFlow.canRetryNavigation
      showReloadHint.value = true
      return
    case 'busy':
      if (result.waitingForPreviousAuth) {
        errorMessage.value = WAITING_FOR_AUTH_MESSAGE
        showReloadHint.value = true
      } else if (result.navigationPending) {
        errorMessage.value = NAVIGATION_WAITING_MESSAGE
        canRetryNavigation.value = loginFlow.canRetryNavigation
        showReloadHint.value = true
      }
      return
    default:
      return
  }
}

// ログイン処理
const handleLogin = async () => {
  if (!canLogin.value) return
  // 実行中は、ボタンの無効化だけに頼らず、ここでも受け付けない（指示書 A-03）
  if (loginFlow.busy || loginFlow.navigationPending) {
    applyLoginResult({ kind: 'busy', waitingForPreviousAuth: loginFlow.waitingForPreviousAuth, navigationPending: loginFlow.navigationPending })
    return
  }

  // 観測（指示書A7）。結果を変えない・awaitしない
  beginLoginAttempt({ entry: isManagerLoginEntry.value ? 'manager_login' : 'login' })

  isLoading.value = true
  errorMessage.value = ''
  successMessage.value = ''
  showReloadHint.value = false
  canRetryNavigation.value = false

  // ログイン後の遷移先: /manager/login なら管理画面へ、それ以外は /top（実際の行き先はルーターのガードが決める）
  const nextPath = isManagerLoginEntry.value ? '/manager' : '/top'
  const result = await loginFlow.submit({
    email: loginForm.value.email,
    password: loginForm.value.password,
    nextPath
  })
  applyLoginResult(result)
}

// 認証済みで、遷移だけが失敗したとき（パスワードは送り直さない）
const retryNavigationAfterLogin = async () => {
  errorMessage.value = ''
  isLoading.value = true
  const result = await loginFlow.retryNavigation()
  applyLoginResult(result)
}

const reloadPage = () => {
  window.location.reload()
}

// 新規登録: 重複チェック → Supabase email+password サインアップ（認証メール送信）
const handleSignUp = async () => {
  if (!canSignUp.value) return
  if (signUpForm.value.password !== signUpForm.value.passwordConfirm) {
    errorMessage.value = 'パスワードが一致しません'
    return
  }
  isLoading.value = true
  errorMessage.value = ''
  successMessage.value = ''
  const email = signUpForm.value.email.trim().toLowerCase()
  const password = signUpForm.value.password
  try {
    const checkRes = await fetch(`${getApiBase()}/api/check-existing-user`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    })
    const checkData = await checkRes.json().catch(() => ({}))
    if (!checkRes.ok || !checkData.success) {
      errorMessage.value = checkData.error || '確認に失敗しました'
      return
    }
    if (checkData.exists) {
      errorMessage.value = checkData.message || 'このメールアドレスは既に登録されています。ログインしてください。'
      return
    }
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: `${window.location.origin}/signup/verify`
      }
    })
    if (error) throw error
    emailLinkSent.value = true
    signUpForm.value.password = ''
    signUpForm.value.passwordConfirm = ''
  } catch (e) {
    console.error('handleSendMagicLink:', e)
    errorMessage.value = e.message || 'メールの送信に失敗しました'
  } finally {
    isLoading.value = false
  }
}

// 認証メール再送
const handleResendSignUp = async () => {
  await handleSignUp()
  if (!errorMessage.value) {
    successMessage.value = 'メールを再送しました'
    setTimeout(() => { successMessage.value = '' }, 3000)
  }
}

const resetEmailSent = () => {
  emailLinkSent.value = false
  errorMessage.value = ''
}

// パスワードリセット
const handlePasswordReset = async () => {
  if (!canReset.value) return
  
  isLoading.value = true
  errorMessage.value = ''
  
  try {
    const { error } = await supabase.auth.resetPasswordForEmail(resetForm.value.email, {
      redirectTo: `${window.location.origin}/reset-password`
    })
    
    if (error) throw error
    
    successMessage.value = 'パスワードリセット用のメールを送信しました！'
    resetForm.value.email = ''
    
  } catch (error) {
    console.error('パスワードリセットエラー:', error)
    errorMessage.value = error.message || 'パスワードリセットに失敗しました'
  } finally {
    isLoading.value = false
  }
}

// モード切り替え
const switchToSignUp = () => {
  isLoginMode.value = false
  isResetMode.value = false
  errorMessage.value = ''
  successMessage.value = ''
  emailLinkSent.value = false
}

const switchToLogin = () => {
  isLoginMode.value = true
  isResetMode.value = false
  errorMessage.value = ''
  successMessage.value = ''
}

const switchToReset = () => {
  isResetMode.value = true
  errorMessage.value = ''
  successMessage.value = ''
}

// フォームリセット
const resetForms = () => {
  loginForm.value = { email: '', password: '' }
  signUpForm.value = {
    email: '',
    password: '',
    passwordConfirm: '',
    full_name: '',
    plan: 'standard'
  }
  resetForm.value = { email: '' }
  errorMessage.value = ''
  successMessage.value = ''
}
</script>

<style scoped>
.login-recovery-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.auth-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 1rem;
}

.auth-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  width: 100%;
  max-width: 100%;
  margin: 0.5rem;
}

.auth-title {
  text-align: center;
  color: #333;
  margin-bottom: 0.35rem;
  font-size: 1.3rem;
  font-weight: 600;
}

.auth-tagline {
  text-align: center;
  color: #555;
  font-size: 0.95rem;
  margin: 0 0 1.25rem 0;
  line-height: 1.4;
}

/* ログインブロック：既存ユーザー向け */
.login-block {
  width: 100%;
}
.login-heading {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
}
.login-to-signup {
  margin: 1.25rem 0 0;
  padding-top: 1rem;
  border-top: 1px solid #e1e5e9;
  text-align: center;
}
.btn-link-signup {
  font-weight: 600;
  font-size: 0.95rem;
}

/* 無料体験登録ブロック見出し */
.signup-heading {
  margin: 0 0 0.75rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* サインアップセクション（スマホファースト） */
.signup-section {
  width: 100%;
}

.signup-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  text-align: center;
}

.signup-hero {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  line-height: 1.6;
  margin: 0 0 0.5rem 0;
}

.signup-hero-accent {
  color: #c53030;
  font-weight: 700;
}

.signup-form .signup-br {
  display: block;
}

.signup-lead {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.7;
  margin: 0 0 1rem 0;
  text-align: center;
}

.signup-form .form-group {
  text-align: left;
  margin-bottom: 0;
}

.signup-submit {
  min-height: 48px;
  font-size: 1rem;
}

/* メール送信完了パネル：色と配置で「送った」ことが一目でわかる */
.signup-success-panel {
  background: linear-gradient(180deg, #ecfdf5 0%, #d1fae5 100%);
  border: 2px solid #10b981;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 0;
  text-align: center;
}

.signup-success-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 1rem;
  background: #10b981;
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 48px;
  border-radius: 50%;
}

.signup-success-title {
  margin: 0 0 1rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #065f46;
}

.signup-success-body {
  text-align: left;
  margin-bottom: 1.25rem;
}

.signup-success-body p {
  margin: 0 0 0.75rem;
  font-size: 0.95rem;
  color: #047857;
  line-height: 1.6;
}

.signup-success-body p:last-child {
  margin-bottom: 0;
}

.signup-success-note {
  font-size: 0.85rem !important;
  color: #059669 !important;
}

.signup-success-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: stretch;
  margin-top: 1rem;
}

.btn-outline {
  background: #ecfdf5;
  color: #065f46;
  border: 1px solid #6ee7b7;
  padding: 0.7rem 1.2rem;
  border-radius: 9999px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
}

.btn-outline:hover {
  background: #6ee7b7;
  color: #064e3b;
}

.signup-form .signup-note {
  font-size: 0.8rem;
  color: #777;
  margin: 0;
  line-height: 1.5;
}

@media (min-width: 480px) {
  .signup-hero {
    font-size: 1.35rem;
  }
  .signup-form .signup-br {
    display: none;
  }
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 1rem;
}

.form-group:last-child {
  margin-bottom: 0;
}

.child-info-note {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e1e5e9;
}

.child-info-note p {
  margin: 0;
  font-size: 0.8rem;
  color: #888;
  line-height: 1.4;
  text-align: center;
}

.form-group label {
  font-weight: 500;
  color: #555;
  font-size: 0.9rem;
}

.form-input {
  padding: 0.6rem;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s;
  width: 100%;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
}

.form-input-error {
  border-color: #c53030;
}

.form-input-error:focus {
  border-color: #c53030;
}

.form-error-inline {
  margin: 0.35rem 0 0;
  font-size: 0.85rem;
  color: #c53030;
}

.btn {
  padding: 0.8rem 1rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: #667eea;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #5a6fd8;
  transform: translateY(-1px);
}

.auth-links {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-top: 1rem;
  align-items: center;
}

.btn-link {
  background: none;
  border: none;
  color: #667eea;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: underline;
}

.btn-link:hover {
  color: #5a6fd8;
}

.error-message {
  background: #fee;
  color: #c53030;
  padding: 0.75rem;
  border-radius: 8px;
  margin-top: 1rem;
  font-size: 0.9rem;
}

.success-message {
  background: #f0fff4;
  color: #22543d;
  padding: 0.75rem;
  border-radius: 8px;
  margin-top: 1rem;
  font-size: 0.9rem;
}

.form-section {
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  padding: 0.8rem;
  margin-bottom: 0.8rem;
}

.form-section h4 {
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1rem;
  font-weight: 600;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.8rem;
  position: relative;
  flex-wrap: wrap;
}

.section-header h4 {
  margin: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}

.section-title-center {
  text-align: center;
}

.security-badge-small {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  background: #10b981;
  color: white;
  padding: 0.2rem 0.4rem;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;
}

.security-icon-small {
  font-size: 0.8rem;
}

.security-text-small {
  font-size: 0.7rem;
}

.card-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
}

.card-details .form-group {
  min-width: 0;
  margin-bottom: 0;
}

.card-details .form-input {
  width: 100%;
  box-sizing: border-box;
}

.trial-info {
  background: #f0fff4;
  border: 1px solid #9ae6b4;
  border-radius: 8px;
  padding: 1rem;
  margin: 1rem 0;
}

.trial-info p {
  margin: 0.25rem 0;
  font-size: 0.9rem;
  color: #22543d;
}

.free-trial {
  color: #e53e3e;
  font-weight: 700;
  font-size: 1.1em;
}

.payment-security-info {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  margin: 0.8rem 0;
}

/* 大きなセキュリティバッジは削除（右上に移動） */

.trial-details h5 {
  margin: 0 0 0.75rem 0;
  color: #1f2937;
  font-size: 1rem;
  font-weight: 600;
}

.payment-title-center {
  text-align: center;
}

.trial-details ul {
  margin: 0;
  padding-left: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.trial-details li {
  margin: 0.5rem 0;
  font-size: 0.9rem;
  color: #374151;
  line-height: 1.5;
  width: 100%;
  text-align: center;
}

.trial-details li strong {
  color: #1f2937;
  font-weight: 600;
}

.trial-highlight {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  background: #fef3c7;
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  border-left: 4px solid #f59e0b;
  margin: 0.4rem 0;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

.trial-highlight strong {
  color: #d97706;
  font-size: 1.2rem;
}

.learner-info {
  background: #f0fff4;
  border: 1px solid #9ae6b4;
  border-radius: 8px;
  padding: 1rem;
  margin: 1rem 0;
}

.learner-info p {
  margin: 0.25rem 0;
  font-size: 0.9rem;
  color: #22543d;
}

.form-help {
  font-size: 0.8rem;
  color: #666;
  margin-top: 0.25rem;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  cursor: pointer;
}

.checkbox-input {
  margin-top: 0.25rem;
  cursor: pointer;
}

.checkbox-text {
  font-size: 0.9rem;
  line-height: 1.4;
}

.link {
  color: #667eea;
  text-decoration: underline;
}

.link:hover {
  color: #5a6fd8;
}

/* スマホでの表示を最適化 */
@media (max-width: 768px) {
  .auth-container {
    padding: 0.75rem;
    padding-top: max(1.5rem, env(safe-area-inset-top));
    padding-bottom: max(0.75rem, env(safe-area-inset-bottom));
    align-items: flex-start;
  }
  
  .auth-card {
    padding: 1.25rem;
    margin: 0.25rem;
    border-radius: 12px;
    max-width: 420px;
  }
  
  .auth-title {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
  
  .signup-section .signup-hero {
    font-size: 1.15rem;
    line-height: 1.65;
  }
  
  .signup-section .signup-lead {
    font-size: 0.9rem;
  }
  
  .signup-section .signup-note {
    font-size: 0.75rem;
  }
  
  .login-heading,
  .signup-heading {
    font-size: 1.05rem;
  }
  
  .form-section h4 {
    font-size: 0.95rem;
    margin-bottom: 0.8rem;
  }
  
  .form-group label {
    font-size: 0.85rem;
  }
  
  .btn {
    padding: 0.7rem 0.8rem;
    font-size: 0.95rem;
  }
  
  .trial-highlight {
    font-size: 1rem;
    padding: 0.4rem;
  }
  
  .trial-highlight strong {
    font-size: 1.1rem;
  }
  
  .security-badge-small {
    padding: 0.2rem 0.4rem;
    font-size: 0.7rem;
  }
  
  .security-text-small {
    font-size: 0.65rem;
  }
}
</style>
